var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-link",on:{"click":_vm.onClick}},[_c('q-icon',{attrs:{"name":"chevron_right"}}),_vm._v(_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }